import React, {ReactNode} from 'react';
import Popup from 'reactjs-popup';
import Menu from '@/components/UiElements/Menu';

export type MenuItem = {
    title?: string | ReactNode;
    icon?: string;
    onClick?: () => void;
    separator?: boolean;
    className?: string;
    disabled?: boolean;
};

interface PopoverProps {
    placement?: any;
    toggle: (open: boolean) => ReactNode;
    content?: ReactNode | ((close: () => void) => ReactNode);
    menu?: MenuItem[];
    offsetX?: number;
    offsetY?: number;
}

const CustomPopover: React.FC<PopoverProps> = ({placement = 'bottom left', toggle, content, menu, offsetY = -10, offsetX=10}) => {


    return (
        <div>
            <Popup
                trigger={open => (
                    <div className='button'>
                        {toggle(open)}
                    </div>
                )}
                //open={isOpen}
                position={placement}
                //onClose={togglePopover}
                closeOnDocumentClick
                keepTooltipInside
                arrowStyle={{color: '#C2E1B7'}}
                repositionOnResize
                closeOnEscape
                //nested
                arrow={false}
                offsetY={offsetY}
                offsetX={offsetX}


            >

                {
                    // @ts-ignore
                    (close: any) => {
                        return (
                            <div
                                className={'bg-white border border-primary-500 shadow-focus min-w-[200px] rounded-md p-[4px] overflow-hidden'}>
                                {menu?.length
                                    ? <Menu items={menu} onClick={close}/>
                                    : typeof content === 'function' ? content(close) : content}
                            </div>
                        )
                    }}

            </Popup>
        </div>
    );
};

export default CustomPopover;
